angular.module("registrace")

    .controller('RegistraceSimpleCtrl', ["$scope", "$http", "$location", "api", "Registrace", "Container", function ($scope, $http, $location, api, Registrace, Container) {

        $scope.blured = {};
        $scope.deaktivateApp = deaktivateApp;
        $scope.data = {
            identificator:null,
            captcha:null,
            loading: false,
            siteKey:null,
            ref: null
        };

        if ($scope.deaktivateApp === true || $scope.deaktivateApp === "true") {
            api.msg('Omlouváme se Vám, ale tato aplikace je dočasně nedostupná, zkuste to prosím později.', 'ERROR', 'NG-APPD', '001');
            return;
        }

        var getParameterByName = function getParameterByName(name, url) {
            if (!url) url = window.location.href;
            name = name.replace(/[\[\]]/g, "\\$&");
            var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
                results = regex.exec(url);
            if (!results) return null;
            if (!results[2]) return '';
            return decodeURIComponent(results[2].replace(/\+/g, " "));
        };

        var init = function () {
            if (location.search.match(/zpnd/) || location.search.match(/cdi/)) {
                $location.path("/registrace");
            }

            Registrace.getSiteKey().success(function (response) {
                $scope.data.siteKey = response;
            });

            var ref = getParameterByName('ref');
            if (ref) {
                $scope.data.ref = ref;
                Container.setRef(ref);
            }
        };
        init();

        $scope.setBlured = function (elem, blured) {
            $scope.blured[elem] = blured;
        };

        $scope.isBlured = function (elem) {
            return !!$scope.blured[elem];
        };


        $scope.execCaptcha = function(){
            grecaptcha.reset();
            grecaptcha.execute();
        };
        
        $scope.processForm = function (captchaToken) {
            $scope.data.captcha = captchaToken;
            $scope.data.loading = true;
            api.cleanMessages();
            
            Registrace.registerStep0($scope.data)
                .success(function (response) {
                    $scope.data.loading = false;
                    var data = response;
                    if(data.smsSend){
                        window.location.href = '/irj/portal/anonymous/dokonceni-registrace?type=SMS&org='+data.org + '&target=' + data.target + ($scope.data.ref ? '&ref=' + $scope.data.ref : '');
                    } else if(data.emailSend){
                        Container.setTarget(data.target);
                        $location.path("/registrace-email-sent");
                    } else {
                        $location.path("/registrace");
                    }
                })

                .error(function (response) {
                    $scope.data.loading = false;
                });
        };

        window.processForm =  $scope.processForm;

    }]);